import { render, staticRenderFns } from "./completed.vue?vue&type=template&id=4896a042&scoped=true&"
import script from "./completed.vue?vue&type=script&lang=ts&"
export * from "./completed.vue?vue&type=script&lang=ts&"
import style0 from "./completed.vue?vue&type=style&index=0&id=4896a042&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4896a042",
  null
  
)

export default component.exports